import styled from '@emotion/styled'
import tokens from '@lacedltd/design-tokens'
import { Button, mediaQuery } from '@lacedltd/laced-components'

export const ProductActions = styled.div({
  marginTop: tokens.spacing[7],
  paddingBottom: tokens.spacing[9]
})

export const ProductActionsButtonGroup = styled.div({
  display: 'flex',
  flexDirection: 'column',
  margin: 0,

  button: {
    height: '3rem',

    '&:last-child': {
      marginBottom: tokens.spacing[6]
    }
  },

  [mediaQuery.m.min]: {
    flexDirection: 'row-reverse',
    justifyContent: 'space-between',
    gap: '1.25rem'
  }
})

export const ProductActionsButton = styled(Button)({
  '&:not(:last-child)': {
    marginBottom: tokens.spacing[6],
    marginRight: 0
  },

  '&:first-of-type': {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden'
  },

  [mediaQuery.m.min]: {
    //unsetting the padding so loading and add to bag are same width
    '&:first-of-type': {
      padding: 'unset'
    }
  }
})
